<div class="facet-filter mb-3 p-3">
  <ds-search-chart-wrapper [filterConfig]="filter" [inPlaceSearch]="inPlaceSearch">
  </ds-search-chart-wrapper>
  <p class="mt-3 mb-0" *ngIf="showCaption">{{caption}}</p>
</div>
